const UseCaseHospitalitySection = () => {
    return (
        <div>
            <section className="basic-area green-area">
                <div className="container">
                    <div className="basic-flex progress">
                        <img
                            className="basic-flex-phone-screenshot"
                            style={{ width: "340px", height: "680px" }}
                            src="images/katalife-democafe-feedback.png"
                            alt="activities"
                        />

                        <div className="basic-flex__content">
                            <h2>
                                Katalife for Hospitality
                            </h2>
                            <ul>
                                <li><strong>Optimised Hospitality Templates</strong> allows you to create a survey in minutes using our existing survey templates for Hospitality. </li>
                                <li ><br /></li>
                                <li><strong>Stand out from the rest</strong> by knowing what your customers love and what they don’t. So you can wow your customers to drive business growth!</li>
                            </ul>
                            <div className="demo-qr-code-container"  >
                                 <div style={{ maxWidth: "120px", backgroundColor: "white", borderRadius: "10px", padding: "10px", marginTop: "20px", marginBottom: "10px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                                    <a href="https://www.kata.life/feedback/EgBke" style={{ fontSize: "11px", textAlign: "center" }} target="_blank" rel="noopener noreferrer" >
                                        <img style={{ width: "100px", height: "100px", }} src="/images/katalife-qr-code-demo-cafe.png" alt="Katalife demo cafe survey QR Code" />
                                        click or scan </a>
                                </div>
                                 <span className="purple" style={{paddingLeft: "10px"}}>Go ahead and give it a try!  </span>
                              
                               
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
};

export default UseCaseHospitalitySection;
